import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromAuthorisationResponses } from '../models/mapper'
import { Authorisation } from '../models/types'
import { fetchAuthorisationsV2 } from './http'

export async function fetchAuthorisations(
  params: { transitOperationId: number },
  opts?: { signal?: AbortSignal },
): Promise<Authorisation[]> {
  const responses = await fetchAuthorisationsV2(params, opts)
  return fromAuthorisationResponses(responses)
}

export function useFetchAuthorisations(transitOperationId: number | null) {
  return useQuery({
    queryKey: QueryKeys.authorisation.allByParams({ transitOperationId }),
    enabled: !!transitOperationId,
    queryFn: ({ signal }) => fetchAuthorisations({ transitOperationId: transitOperationId as number }, { signal }),
  })
}
